import React from 'react'
import {RUTA_IMAGEN} from '../../utils/rutasFijas';

class ModalApp extends React.Component {


  //FC: simula el click del boton, tiene un ref en el button
  simulateClick(e) {
      if (e)
        e.click();
    }





render () {

    return (
        <div id="loader" className="loader result">
          <button ref={this.simulateClick} type="button" style={{'display': 'none'}} className="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
            Fancy
          </button>

          <div className="modal fade bd-example-modal-lg" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered " role="document">
              <div className="modal-content modal-app" style={{border: 'none', borderRadius: '0'}}>
                {/*
                <div className="modal-body"> 
                 
                  <img alt="Iconos de Playstore" src={`${RUTA_IMAGEN}sobrePedraza/playstore.png`} className="img-responsive" style={{ marginBottom: '10px'}} /> 
                  <img alt="Fondo " src={`${RUTA_IMAGEN}sobrePedraza/fondoIcono.png`} className="img-responsive" style={{display: 'block', margin: '10px auto'}} />
                  <button type="button" className="btnUsarApp" onClick={() => window.location.href = 'https://pedraza.com.ar/redireccionAppStore.html'}>Usar la App</button>
                  <button type="button" className="btnContinuar" data-dismiss="modal">Continuar al sitio Web</button>
			        	</div> 
                nuevo
               */}
                <div className="modal-body"> 
                  <button type="button" className="btnUsarApp" onClick={() => window.location.href = 'https://pedraza.com.ar/redireccionAppStore.html'}>¡DESCARGALA YA!</button>
                 {/*
                  <img alt="Iconos de Playstore" src={`${RUTA_IMAGEN}sobrePedraza/playstore.png`} className="img-responsive" style={{ marginBottom: '10px'}} /> 
                  <img alt="Fondo " src={`${RUTA_IMAGEN}sobrePedraza/modalAppx340.jpg`} className="img-responsive" style={{display: 'block', margin: '10px auto'}} />
                  */}
               </div> 
                <div className="modal-footer" style={{border: 'none', padding: '0'}}>
                    <button type="button" className="btnContinuar" data-dismiss="modal">Continuar al sitio Web</button>
                    {/*
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                      */}
                  </div>
              
              </div>
            </div>
          </div>
        </div>
    )}
}

export default ModalApp



// WEBPACK FOOTER //
// ./src/components/Global/ModalApp.js